import React from 'react';
import { View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import { CommonProperties, Color } from '../../styles';

const PassengerInfo = ({ value, label, extraInfo, seat }) => {
  return (
    <RowView style={styles.wrap}>
      <View>
        <BaseText style={styles.label}>{label}</BaseText>
        <BaseText>{value}</BaseText>
        {extraInfo ? <BaseText>{extraInfo}</BaseText> : null}
      </View>
      {seat ? (
        <View>
          <BaseText style={styles.seat}>Seat</BaseText>
          <BaseText style={styles.number}>{seat}</BaseText>
        </View>
      ) : null}
    </RowView>
  );
};

const styles = StyleSheet.create({
  wrap: {
    justifyContent: 'space-between',
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
  label: {
    color: Color.grayText2,
  },
  seat: {
    color: Color.grayText,
    textAlign: 'right',
    ...CommonProperties.small,
  },
  number: {
    textAlign: 'right',
    ...CommonProperties.h4,
  },
});

export default PassengerInfo;
